import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ISpecialProject } from "../interface/specialProject/ISpecialProject";
import { IBaseResponse } from "../interface/IBaseResponse";
import { IQuestion } from "../interface/Questionnaire/IQuestion";
import { IFillSelect } from '../interface/IFillSelect';
import { IEditSpecialProject } from '../interface/specialProject/IEditSpecialProject';
import { ISpecialProjectUpdateTrades } from "../interface/specialProject/ISpecialProjectUpdateTrades";
import { IReprocessBCheckReproved } from "src/components/common/SpecialProject/BcheckModal/BcheckDetailsView/BcheckDetailsView";

enum SpecialProjectEnum {
  getById = "/",
  getAll = "/get-all",
  getSelect = "/get-select",
  createSpecialProject = "/",
  createTradesBySpecialProject = "/create-trades?idSpecialProject=",
  runBCheck = "/run-bcheck?idSpecialProject=",
  questionnaire = "/questionnaire",
  getTrades = "/get-trades/",
  updateTrades = "/update-trades/",
  processBcheckBatch = "/process-bcheck-batch/",
  reprocessBCheckTrade = "/reprocess-bcheck-reproved"
}

export default class SpecialProjectService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project");
  }

  public getAll = async (): Promise<ISpecialProject[]> => await this.GET(SpecialProjectEnum.getAll);
  public getSelect = async (): Promise<IFillSelect[]> => await this.GET(SpecialProjectEnum.getSelect);
  public getById = async (id: number): Promise<ISpecialProject> => await this.GET(SpecialProjectEnum.getById + id);
  public updateTrades = async (request: ISpecialProjectUpdateTrades): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.updateTrades, request);
  public createSpecialProject = async (data: IEditSpecialProject): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.createSpecialProject, data);
  public createTradesBySpecialProject = async (specialProjectId: number, pricingBatchId: number): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.createTradesBySpecialProject + specialProjectId + "&pricingBatchId=" + pricingBatchId, null);
  public runBCheck = async (id: number, isRerun: boolean): Promise<IBaseResponse> => await this.POST(SpecialProjectEnum.runBCheck + id + "&isRerun=" + isRerun, null);
  public getQuestionnaireModel = async (id: number): Promise<IQuestion[]> => await this.GET(`${SpecialProjectEnum.questionnaire}/${id}`);
  public saveQuestionnaire = async (id: number, questionnaire: IQuestion[]) => await this.POST(`${SpecialProjectEnum.questionnaire}/${id}`, { questionnaire });
  public getTrades = async (specialProjectId: number) => await this.GET(SpecialProjectEnum.getTrades + specialProjectId);
  public processBcheckBatch = async (specialProjectId: number) => this.POST(SpecialProjectEnum.processBcheckBatch + specialProjectId);
  public reprocessBCheckTrade = async (payload: IReprocessBCheckReproved) => this.POST(SpecialProjectEnum.reprocessBCheckTrade, payload);
}
